<template>
  <div style="display: none;"></div>
</template>

<script>
export default {
  name: 'ZetaGlobalScript',
  mounted() {
    this.$nextTick(() => {
      // Universal script
      function zync_call_universal() {
            var z = document.createElement('script');
            var custom1='{product}';
            var custom2='{category}';
            var zmpID='endlesspools';
            var custID='{custID}';
            var categoryID='{categoryID}';
            var productID='{productID}';
            var cache_buster=Date.now();
            var page_referrer=encodeURIComponent(document.referrer);
            var PageUrl=encodeURIComponent(window.top.location.href).replace(/[!'()~]/g, escape).replace(/\*/g, '%2A');
            var z_src = 'https://live.rezync.com/sync?c=16b6410431b6374e780104abb0443ca8&p=b196351d5760b987dc0d68dff766bfb3&k=endlesspools-pixel-2967&custom1='+custom1+'&custom2='+custom2+'&zmpID='+zmpID+'&custID='+custID+'&categoryID='+categoryID+'&productID='+productID+'&cache_buster='+cache_buster+'&page_referrer='+page_referrer+'&PageUrl='+PageUrl;
            z.setAttribute('src', z_src);
            document.body.appendChild(z);
        }
        if (['complete', 'interactive'].indexOf(document.readyState) >= 0) {
          zync_call_universal();
        } else {
            window.addEventListener('DOMContentLoaded', function(){
            zync_call_universal();
        });
      }
    //   zync_call_universal();

      // Form Submit script
      function zync_call_form_submit() {
        var z = document.createElement('script');
        var custom3='{Lead_Form_Type}';
        var zmpID='endlesspools';
        var custID='{custID}';
        var cache_buster=Date.now();
        var page_referrer=encodeURIComponent(document.referrer);
        var PageUrl=encodeURIComponent(window.top.location.href).replace(/[!'()~]/g, escape).replace(/\*/g, '%2A');
        var z_src = 'https://live.rezync.com/sync?c=16b6410431b6374e780104abb0443ca8&p=b196351d5760b987dc0d68dff766bfb3&k=endlesspools-pixel-1218&custom3='+custom3+'&zmpID='+zmpID+'&custID='+custID+'&cache_buster='+cache_buster+'&page_referrer='+page_referrer+'&PageUrl='+PageUrl;
        z.setAttribute('src', z_src);
        document.body.appendChild(z);
    }
    if (['complete', 'interactive'].indexOf(document.readyState) >= 0) {
        zync_call_form_submit();
    } else {
        window.addEventListener('DOMContentLoaded', function(){
            zync_call_form_submit();
        });
      }
    //   zync_call_form_submit();
    });
  }
}
</script>
